import { ElNotification } from 'element-plus'
import { nextTick } from 'vue'

// Element Plus measures previous notifications when positioning the next one.
// Wait for each notification to become visible before creating another.
let notificationQueue = Promise.resolve()

export default {
  notifications: [],
  addNotification(msg, type, time) {
    const hasOptions = typeof msg === 'object' && msg !== null
    const options = hasOptions ? msg : {}
    const message = hasOptions ? options.message || 'Alerta' : msg || 'Alerta'
    const notificationType = options.type || type || 'warning'
    const duration = options.duration || time || 6000

    notificationQueue = notificationQueue.then(async () => {
      ElNotification({
        ...options,
        message,
        type: notificationType,
        duration
      })
      await nextTick()
    })

    let notification = {
      message,
      type: notificationType,
      icon: this.getIconByType(notificationType),
      timeout: setTimeout(() => {
        let index = this.notifications.indexOf(notification)
        this.notifications.splice(index, 1)
      }, duration)
    }
    this.notifications.push(notification)
  },
  success(msg, time) {
    this.addNotification(msg, 'success', time)
  },
  error(err, time) {
    const message = err?.response?.data?.message || err?.message || err || 'Alerta'
    this.addNotification(message, 'error', time)
  },
  warning(msg, time) {
    this.addNotification(msg, 'warning', time)
  },
  info(msg, time) {
    this.addNotification(msg, 'info', time)
  },
  removeNotification(index){
    let notification = this.notifications[index]
    clearTimeout(notification.timeout)
    this.notifications.splice(index, 1)
  },
  getIconByType(type) {
    switch (type) {
      case 'warning':
        return 'exclamation-triangle'
      case 'info':
        return 'bell'
      case 'success':
        return 'check-circle'
      case 'error':
        return 'ban'
      default:
        return 'exclamation-triangle'
    }
  }
}
